export default "__VITE_ASSET__Djk68qGd__"